export default __webpack_public_path__ + "static/Tribunal-Navigator-0833e0321873ea2d282ea2362e59ce85.png";